import { render, staticRenderFns } from "./EventSelectorCard.vue?vue&type=template&id=5c1603c1"
import script from "./EventSelectorCard.vue?vue&type=script&lang=js"
export * from "./EventSelectorCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports